import http from '../utils/http';
import { OCCASIONS } from '../constants/endpoints';
import type { ServiceParams } from 'interface/service';

export async function fetchOccasions(params: ServiceParams) {
  return await http.get(OCCASIONS, { params: { ...params } });
}
